import types from './types';

export function getCurrentUser() {
    return {
        type: types.GET_CURRENT_USER.REQUEST,
    };
}

export function logout() {
    return {
        type: types.LOGOUT
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/user-actions.js